import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getClient, showReportDialog, withScope } from '@sentry/browser';
import { debug } from '@sentry/core';
import * as React from 'react';
import { DEBUG_BUILD } from './debug-build.js';
import { captureReactException } from './error.js';
import { hoistNonReactStatics } from './hoist-non-react-statics.js';
var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null
};

/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = INITIAL_STATE;
    _this._openFallbackReportDialog = true;
    var client = getClient();
    if (client && props.showDialog) {
      _this._openFallbackReportDialog = false;
      _this._cleanupHook = client.on('afterSendEvent', function (event) {
        if (!event.type && _this._lastEventId && event.event_id === _this._lastEventId) {
          showReportDialog(_objectSpread(_objectSpread({}, props.dialogOptions), {}, {
            eventId: _this._lastEventId
          }));
        }
      });
    }
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this2 = this;
      var componentStack = errorInfo.componentStack;
      var _this$props = this.props,
        beforeCapture = _this$props.beforeCapture,
        onError = _this$props.onError,
        showDialog = _this$props.showDialog,
        dialogOptions = _this$props.dialogOptions;
      withScope(function (scope) {
        if (beforeCapture) {
          beforeCapture(scope, error, componentStack);
        }
        var handled = _this2.props.handled != null ? _this2.props.handled : !!_this2.props.fallback;
        var eventId = captureReactException(error, errorInfo, {
          mechanism: {
            handled: handled,
            type: 'auto.function.react.error_boundary'
          }
        });
        if (onError) {
          onError(error, componentStack, eventId);
        }
        if (showDialog) {
          _this2._lastEventId = eventId;
          if (_this2._openFallbackReportDialog) {
            showReportDialog(_objectSpread(_objectSpread({}, dialogOptions), {}, {
              eventId: eventId
            }));
          }
        }

        // componentDidCatch is used over getDerivedStateFromError
        // so that componentStack is accessible through state.
        _this2.setState({
          error: error,
          componentStack: componentStack,
          eventId: eventId
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;
      if (onMount) {
        onMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state = this.state,
        error = _this$state.error,
        componentStack = _this$state.componentStack,
        eventId = _this$state.eventId;
      var onUnmount = this.props.onUnmount;
      if (onUnmount) {
        if (this.state === INITIAL_STATE) {
          // If the error boundary never encountered an error, call onUnmount with null values
          onUnmount(null, null, null);
        } else {
          // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
          // when the error boundary has already encountered an error.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          onUnmount(error, componentStack, eventId);
        }
      }
      if (this._cleanupHook) {
        this._cleanupHook();
        this._cleanupHook = undefined;
      }
    }
  }, {
    key: "resetErrorBoundary",
    value: function resetErrorBoundary() {
      var onReset = this.props.onReset;
      var _this$state2 = this.state,
        error = _this$state2.error,
        componentStack = _this$state2.componentStack,
        eventId = _this$state2.eventId;
      if (onReset) {
        // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
      }
      this.setState(INITIAL_STATE);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        fallback = _this$props2.fallback,
        children = _this$props2.children;
      var state = this.state;

      // `componentStack` is only null in the initial state, when no error has been captured.
      // If an error has been captured, `componentStack` will be a string.
      // We cannot check `state.error` because null can be thrown as an error.
      if (state.componentStack === null) {
        return typeof children === 'function' ? children() : children;
      }
      var element = typeof fallback === 'function' ? React.createElement(fallback, {
        error: state.error,
        componentStack: state.componentStack,
        resetError: function resetError() {
          return _this3.resetErrorBoundary();
        },
        eventId: state.eventId
      }) : fallback;
      if (React.isValidElement(element)) {
        return element;
      }
      if (fallback) {
        DEBUG_BUILD && debug.warn('fallback did not produce a valid ReactElement');
      }

      // Fail gracefully if no fallback provided or is not valid
      return null;
    }
  }]);
}(React.Component); // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
  var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
  var Wrapped = React.memo(function (props) {
    return React.createElement(ErrorBoundary, _objectSpread({}, errorBoundaryOptions), React.createElement(WrappedComponent, _objectSpread({}, props)));
  });
  Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")");

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}
export { ErrorBoundary, UNKNOWN_COMPONENT, withErrorBoundary };